import React from 'react'

import { useNavigate } from 'react-router-dom'
import { Box, Spinner } from '@chakra-ui/react'

import { useCandidate } from '@/react-query/candidate'
import { useInterview } from '@/react-query/interview/interview'
import { useLocalRecording } from '@/react-query/local-recording'
import { useDocumentTitle } from '@/views/hooks/useDocumentTitle'
import { CandidateCard } from '@/views/screens/Interview/components/CandidateCard/CandidateCard'
import { InputTranscriptProvider } from '@/views/screens/Interview/components/FullTranscript/context/InputTranscriptContext'
import { InterviewCard } from '@/views/screens/Interview/components/InterviewCard'
import { InterviewerCard } from '@/views/screens/Interview/components/InterviewerCard/InterviewerCard'
import { RoleCard } from '@/views/screens/Interview/components/RoleCard/RoleCard'
import { InterviewDataProvider } from '@/views/screens/Interview/context'
import { AudioRecorderProvider } from '@/views/screens/Interview/context/AudioRecorderContext/AudioRecorderContext'
import { useDynamicHeader } from '@/views/screens/Interview/hooks/useDynamicHeader'
import { useWaitForTranscriptGeneration } from '@/views/screens/Interview/hooks/useWaitForTranscriptGeneration'

import { CompanyCard } from './components/CompanyCard/CompanyCard'

const Interview: React.FC = () => {
  const navigate = useNavigate()
  const {
    data: interview,
    isLoading: isLoadingExistingInterview,
    isError,
  } = useInterview()
  const localRecording = useLocalRecording()
  const interviewType = interview?.type
  if (isError) {
    navigate('/home')
  }

  const candidate = useCandidate()

  let title: string
  if (isLoadingExistingInterview) {
    title = 'Interview'
  } else if (candidate.data?.fullName) {
    title = candidate.data.fullName
  } else if (interview?.meetingName) {
    title = interview.meetingName
  } else {
    title = 'Interview'
  }

  useDocumentTitle(title)

  useDynamicHeader()
  useWaitForTranscriptGeneration()

  if (isLoadingExistingInterview || localRecording.isLoading) {
    return (
      <div className="flex flex-col flex-grow">
        <Spinner className="m-auto w-10 h-10" />
      </div>
    )
  }

  return (
    <Box
      display={'flex'}
      flexDirection={{
        base: 'column',
        lg: 'row',
      }}
      flexGrow={1}
      mt={10}
    >
      <Box
        display="flex"
        flexDirection={'column'}
        flexShrink={0}
        w={{
          base: '100%',
          lg: '17rem',
          xl: '22rem',
        }}
      >
        <CandidateCard />
        <RoleCard />
        {interviewType === 'INTAKE' && <CompanyCard />}
        <InterviewerCard />
      </Box>
      <InterviewCard />
    </Box>
  )
}

const InterviewWithContext = () => {
  return (
    <InterviewDataProvider>
      <InputTranscriptProvider>
        <AudioRecorderProvider>
          <Interview />
        </AudioRecorderProvider>
      </InputTranscriptProvider>
    </InterviewDataProvider>
  )
}

export default InterviewWithContext
